
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ios/extreme-verification",
      function () {
        return require("private-next-pages/ios/extreme-verification/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ios/extreme-verification"])
      });
    }
  